if (!window.Promise) {
  var Promise = require('promise-polyfill')
  window.Promise = Promise
}

Object.assign = require('object-assign')



//////////////////
// WEBPACK FOOTER
// ./node_modules/web-polyfill/index.js
// module id = 41
// module chunks = 0